import { Component, inject } from '@angular/core';

import { RDS_DIALOG_DATA, RdsDialogRef } from '@rds/angular-components';

type ConfirmDialogOption = { 
    body: string,
    data: string 
    title?: string, 
    type: string,
    confirmButtonText?: string,
 }

@Component({
    selector: 'app-confirm',
    templateUrl: './confirm.component.html',
    styleUrls: ['./confirm.component.scss'],
    standalone: false
})
export class ConfirmComponent {
    protected readonly data: ConfirmDialogOption = inject(RDS_DIALOG_DATA) as ConfirmDialogOption;

    public readonly rdsDialogRef =
        inject<RdsDialogRef<ConfirmComponent>>(RdsDialogRef);

    closeDialog(value: string) {
        this.rdsDialogRef.close(value);
    }
}
